// extracted by mini-css-extract-plugin
export default {"poweredBy":"style_poweredBy__RcDC0"};